<template>
  <el-card :class="['box-card',optStatusEdit?'':''] " style="height: 30%;">
    <div slot="header" style="padding: 2px 0">
      <span>{{ $t('SystemMaintenance.APIOutputAdditionalInformation') }}</span>
    </div>
    <cargo-ag-grid
      :grid-params.sync="gridParams"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
    />
    <div>
      <el-button type="primary" :disabled="!optStatusEdit" @click="addHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
      <el-button type="danger" :disabled="!optStatusEdit" @click="removeHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
    </div>
  </el-card>
</template>

<script>
import * as trackingDetailNotifyExtApi from '@/api/sysManage/baseConfig/trackingDetailNotifyExt'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'

export default {
  name: 'TrackingDetailNotifyExtPanel',
  props: {
    optStatusEdit: { type: Boolean, required: true },
    isNew: { type: Boolean, required: true },
    trackingDetail: { type: Object, default: null }
  },
  data() {
    return {
      sopWarningConfig: {
        trackInfoId: '',
        trackInfoDetailId: '',
        open: true,
        warningDateField: 0,
        warningType: 0,
        warningHour: 0,
        warningLevel: 0
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        }
      },
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '输出说明',
          field: 'messageDesc',
          width: 100,
          editable: this.optStatusEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('SystemMaintenance.OutputIdentification'),
          field: 'messageCode',
          width: 100,
          editable: this.optStatusEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('SystemMaintenance.DataSource'),
          field: 'entityName',
          width: 100,
          editable: this.optStatusEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('SystemMaintenance.DataField'),
          field: 'fieldName',
          width: 100,
          editable: this.optStatusEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('SystemMaintenance.Remark'),
          field: 'remarks',
          width: 100,
          editable: this.optStatusEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
    }
  },
  watch: {
    isNew(newVal) {
      if (newVal) {
        this.rowData = []
      }
    }
  },
  created() {
    this.loadTrackingDetailNotifyExt()
  },
  methods: {
    loadTrackingDetailNotifyExt(trackingDetailUuid) {
      this.rowData = []
      if (this.trackingDetail && this.trackingDetail.uuid || trackingDetailUuid) {
        const loading = getLoading()
        trackingDetailUuid = trackingDetailUuid || this.trackingDetail.uuid
        trackingDetailNotifyExtApi.loadTrackingDetailNotifyExt({ trackingDetailUuid }).then(resp => {
          this.rowData = resp.data
        }).finally(() => loading.close())
      }
    },
    addHandler() {
      const tnf = {}
      tnf.trackingDetailUuid = this.trackingDetail.uuid
      tnf.isDirty = true
      this.rowData.push(tnf)
      this.gridOptions.api.refreshCells({ force: true })
    },
    removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && this.rowData.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        return
      }
      const notifyExt = node.data
      if (!notifyExt.uuid) {
        const index = this.rowData.findIndex(row => row.uuid === notifyExt.uuid)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
      } else {
        // 获取
        const loading = getLoading()
        trackingDetailNotifyExtApi.remove({ trackingDetailUuid: notifyExt.uuid }).then(resp => {
          this.loadTrackingDetailNotifyExt()
        }).finally(() => loading.close())
      }
    },
    save(trackingDetailUuid) {
      const result = []
      for (const tnf of this.rowData) {
        if (tnf.isDirty) {
          result.push(tnf)
        }
      }
      if (trackingDetailUuid) {
        for (const el of result) {
          if (!el.trackingDetailUuid) {
            el.trackingDetailUuid = trackingDetailUuid
          }
        }
      }
      if (result.length > 0) {
        trackingDetailNotifyExtApi.batchSave(result)
      }
    },
    onCellChange(params) {
      params.data.isDirty = true
    }
  }
}
</script>

<style scoped>

</style>
